export const brandNames = {
  ED: 'eDreams',
  OP: 'Opodo',
  TR: 'Travellink',
  GO: 'GO Voyages',
};
